import {NavLink} from 'react-router-dom';

import './Products.css';
import "../components/Header.css";
import Footer from '../components/Footer.js';
import Header from '../components/Header.js';

import img1 from '../media/images/daddy_daughter.jpg';
import img2 from '../media/images/unnamed.jpg';
import Premium_Pack_video from '../media/images/Premium_Pack.mp4'


function Products() {
    return (
      <div className='Products-screen'>
        <Header></Header>
        {/* <Navbar></Navbar> */}
        <main className='Products-main-container'>
          
            {/* <div className='Products-descriptions' >
              <h6>We can customize anything to your wishes! Three are 3 different tiers to choose for your event.
              The tiers are set depending on the size of your event. </h6>
            </div> */}
           
 
            
            <PRODUCTS_ITEM 
              className="Engagement-container" 
              className2="Products-headings-container" 
              className3= "Product-images-E" 
              text = "Starter Pack"
              desc=  "This includes one large hand carved watermelon tray and hand carved fruits"
              price ="$95"
              text2 ="Medium Pack"
              desc2 ="The medium pack includes the starter pack and one large deliciously decorated plate"
              price2="$175"
              text3 = "Premium Pack"
              desc3 ="The premium pack includes the medium pack and two additional plates"
              price3="$330"
              img1 = {img1}
              img2 = {img2}
              img3 = {Premium_Pack_video}/>
              
            <div className='Products-paragraph'>
              <h1>Your Dream Fruit Creations</h1>
              <p>
              Can't find the perfect table decorations? Let us bring your vission to life with custom designed creations.
              With unique flavors and personalized design, we will create your fruit creation for your special events.
              Build you fruit creations with us today!
              </p> 

            </div>

            <NavLink className = 'order_link_but' to='/order' >
                <button className='button'>ORDER NOW</button>
            </NavLink>

        </main>
        <div className='footer-test'>
        <Footer></Footer>
      </div>
    </div>
    );
  }
  
  export default Products;


  function PRODUCTS_ITEM({className ,className2, className3, text,desc,price,text2,desc2,price2,text3,desc3,price3,img1,img2,img3}) {
    return(
    <div className={className}>  
      <div className='Card'>
      <div className='starter-pack'>
          <h2 className="Pack_heading">{text}</h2>
          <div className="image_div"><img className={className3} src={img1} alt="Starter pack"></img></div>
          <p className={className2}>{desc} <br/><br/>0 Persons</p>
          <p className="Price">{price}</p>
      </div>
    </div>
    <div className='Card'>
    <div className='middle-pack'>
      <div>
          <h2 className="Pack_heading">{text2} </h2>
          <div className="image_div"><img className={className3} src={img2} alt="Medium pack"></img></div>
        </div>
          <p className={className2}>{desc2} <br/><br/>20-30 Persons</p>
          <p className="Price">{price2}</p>
      </div>
      </div>

      <div className='Card'>
      <div className='premium-pack'>
      <div>
          {/* <div><img className={className3} src={img3}></img></div> */}
          {/* width='400px' height='400px' */}

          <div >
          <h2 className="Pack_heading">{text3}</h2>
          <video className={className3} controls>
               <source src={Premium_Pack_video} type="video/mp4"/>
           </video>

           </div>
        </div>
          <p className={className2}>{desc3}  <br/><br/>80-100 Persons</p>
          <p className="Price">{price3}</p>
      </div>
      </div>
    </div>
    )

  }